import { email } from "../../constants/themeConstants";

function PrivacyPolicy() {
  return (
    <>
      <div className="bg-banner2 flex items-center justify-center min-h-[200px] max-h-[200px] md:min-h-[300px] md:max-h-[300px] bg-cover bg-center">
        <h1 className="z-10 text-white bg-[#7b026b]/30 w-max px-10 py-2 md:py-5 text-[16px] md:text-[20px] uppercase font-heading">
          Privacy Policy
        </h1>
        <div className='bg-black/60 absolute w-full min-h-[200px] max-h-[200px] md:min-h-[300px] md:max-h-[300px]'>
        </div>
      </div>

      <div className="w-[80%] mx-auto py-[40px]">
        <h2 data-aos="fade-left" className="mb-4 font-heading text-[#7b026b] text-[16px]">Last Updated On : 9th Nov 2026</h2>
        <p data-aos="fade-up" className="font-body text-[15px] mb-3">
          At <strong className="font-heading">IGPH Kamalanagar</strong>, the developer of the
          <strong> Stuthi Aaradhane Geethegalu</strong> app, we value your privacy and are committed to protecting your
          personal information. This Privacy Policy explains how we handle your data when you use our
          mobile application or related services.
        </p>

        <h1 data-aos="fade-up" className="font-heading text-[14px] mt-4 mb-3">1. Information We Collect</h1>
        <p data-aos="fade-up" className="font-body text-[15px] mb-3">
          We collect only the minimal data required to provide a smooth experience, such as:
        </p>
        <ul data-aos="fade-up" className="list-disc pl-6 font-body text-[15px] mb-3">
          <li>Your name and contact details (only if you choose to share them).</li>
          <li>Basic analytics data to help us improve app performance.</li>
        </ul>

        <h1 data-aos="fade-up" className="font-heading text-[14px] mt-4 mb-3">2. Google Authentication</h1>
        <p data-aos="fade-up" className="font-body text-[15px] mb-3">
          The STUTHI ARADHANE GEETHEGALU Stuthi Aaradhane Geethegalu app  may use <strong>Google Authentication</strong> for a secure and easy login.
          We only access your <strong>Google email ID</strong> for verification purposes.
        </p>
        <ul data-aos="fade-up" className="list-disc pl-6 font-body text-[15px] mb-3">
          <li>Your Google password or contacts are <strong>never accessed or stored</strong>.</li>
          <li>Your email is handled with confidentiality and is never shared with third parties.</li>
        </ul>

        <h1 data-aos="fade-up" className="font-heading text-[14px] mt-4 mb-3">3. Use of Information</h1>
        <ul data-aos="fade-up" className="list-disc pl-6 font-body text-[15px] mb-3">
          <li>To authenticate users securely.</li>
          <li>To personalize your app experience and provide relevant updates.</li>
          <li>To maintain and improve app functionality.</li>
        </ul>

        <h1 data-aos="fade-up" className="font-heading text-[14px] mt-4 mb-3">4. Data Protection</h1>
        <p data-aos="fade-up" className="font-body text-[15px] mb-3">
          Your information is securely stored and only accessible to authorized personnel for
          operational purposes.
        </p>

        <h1 data-aos="fade-up" className="font-heading text-[14px] mt-4 mb-3">5. Cookies & Analytics</h1>
        <p data-aos="fade-up" className="font-body text-[15px] mb-3">
          The STUTHI ARADHANE GEETHEGALU Stuthi Aaradhane Geethegalu app  may use cookies or third-party analytics tools to improve user experience.
          You can disable these through your device settings at any time.
        </p>

        <h1 data-aos="fade-up" className="font-heading text-[14px] mt-4 mb-3">6. Third-Party Services</h1>
        <p data-aos="fade-up" className="font-body text-[15px] mb-3">
          Our app may use trusted third-party services (such as Google Play Services or Firebase) to
          improve performance and reliability. These services have their own privacy policies.
        </p>

        <h1 data-aos="fade-up" className="font-heading text-[14px] mt-4 mb-3">7. Changes to This Policy</h1>
        <p data-aos="fade-up" className="font-body text-[15px] mb-3">
          We may update this Privacy Policy occasionally. The latest version will always be available
          within the app or on our official website.
        </p>

        <h1 data-aos="fade-up" className="font-heading text-[14px] mt-4 mb-3">8. Contact Us</h1>
        <p data-aos="fade-up" className="font-body text-[15px] mb-3">
          If you have questions or concerns about our Privacy Policy or data practices, please contact
          us at <strong className="font-heading">{email}</strong>.
        </p>

        <p data-aos="fade-up" className="font-body text-[15px] italic mt-4">
          Thank you for using the STUTHI ARADHANE GEETHEGALU Stuthi Aaradhane Geethegalu app . We’re honored to share uplifting music and content that
          inspires peace and joy.
        </p>
      </div>
    </>
  );
}

export default PrivacyPolicy;
